import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-oferta-academica',
  templateUrl: './oferta-academica.component.html',
  styleUrls: ['./oferta-academica.component.scss'],
  providers: [DatePipe]
})

export class OfertaAcademicaComponent implements OnInit {

  tituloPantalla = "OFERTA ACADÉMICA";

  @Input() cintillo = "";
  @Input() ahora: Date = null;

  constructor(private datePipe: DatePipe) { }

  ngOnInit(): void {
  }

}
